var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock 1",
    clipPath: "url(#clip0_743_93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0013 0.916504C9.00701 0.916504 7.0575 1.50788 5.39931 2.61585C3.74111 3.72382 2.44871 5.29862 1.68552 7.14111C0.922338 8.9836 0.722654 11.011 1.11172 12.967C1.50079 14.923 2.46113 16.7197 3.87131 18.1298C5.28149 19.54 7.07817 20.5004 9.03415 20.8894C10.9901 21.2785 13.0175 21.0788 14.86 20.3156C16.7025 19.5524 18.2773 18.26 19.3853 16.6018C20.4933 14.9436 21.0846 12.9941 21.0846 10.9998C21.0815 8.32654 20.0181 5.76364 18.1278 3.87333C16.2375 1.98302 13.6746 0.919658 11.0013 0.916504ZM14.3994 14.3979C14.2275 14.5698 13.9944 14.6663 13.7513 14.6663C13.5082 14.6663 13.2751 14.5698 13.1032 14.3979L10.3532 11.6479C10.1813 11.4761 10.0847 11.2429 10.0846 10.9998V5.49984C10.0846 5.25672 10.1812 5.02356 10.3531 4.85166C10.525 4.67975 10.7582 4.58317 11.0013 4.58317C11.2444 4.58317 11.4776 4.67975 11.6495 4.85166C11.8214 5.02356 11.918 5.25672 11.918 5.49984V10.6203L14.3994 13.1018C14.5712 13.2737 14.6678 13.5068 14.6678 13.7498C14.6678 13.9929 14.5712 14.226 14.3994 14.3979Z",
    fill: "#666666"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_93"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.5374a1087c9277be03dcb180a703648f.svg";
export { ForwardRef as ReactComponent };